import React from "react";
import Flagship from "../../core/flagship";
import Field from "./Field";
import { Table, Loader, Button, Header, Modal, Icon } from "semantic-ui-react";
import { setAsyncRouteLeaveHook, shouldShowField } from "../../utils/helpers";

class SingleRecordEdit extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      recordFields: [],
    };
  }

  componentWillMount() {
    setAsyncRouteLeaveHook(
      this.props.router,
      this.props.route,
      this.routerWillLeave.bind(this)
    );
  }

  routerWillLeave(url) {
    let modified = this.props.modified;
    let showLeaveConfirmation = this.props.showLeaveConfirmation;
    return new Promise((resolve) => {
      if (!modified) {
        // No unsaved changes -- leave
        resolve(true);
      } else {
        // Unsaved changes -- ask for confirmation
        showLeaveConfirmation(url);

        resolve(false);
      }
    });
  }

  onChange(e, value, i) {
    this.props.editModeChange(e, value, i);
  }

  onChangeName(e, value) {
    this.props.onChangeName(e, value);
  }

  onChangeExtra(e, value, which) {
    this.props.onChangeExtra(e, value, which);
  }

  render() {
    if (typeof this.props.recordData === "undefined") {
      return (
        <Table className="fade-in">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="5">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    } else {
      let self = this;
      let ioService;

      if (this.props.route.type === "io") {
        let found = Flagship.config.lineItemServices.find(function (element) {
          return element.value === self.props.recordData.record.extra3;
        });
        if (typeof found !== "undefined" && found.hasOwnProperty("text")) {
          ioService = found.text;
        }
      }
      return (
        <div className="fade-in" style={{ marginTop: "2em" }}>
          {this.props.route.type === "io" ? (
            <Header as="h3" content={ioService} />
          ) : null}
          <Field
            addError={self.props.addError}
            clearError={self.props.clearError}
            recordId={self.props.recordData.record.id}
            key={"field-name"}
            id="recordName"
            label={this.props.route.niceName + " Name"}
            value={this.props.name}
            onChange={(e, value) => self.onChangeName(e, value)}
          />
          <Field
            addError={self.props.addError}
            clearError={self.props.clearError}
            recordId={self.props.recordData.record.id}
            key={"field-extra1"}
            id="recordExtra1"
            {...Flagship.config.records[this.props.route.type].extra1}
            value={this.props.extra1}
            expanded={false}
            onChange={(e, value) => self.onChangeExtra(e, value, "extra1")}
          />

          {this.props.route.type === "io" &&
          this.props.extra1 &&
          this.props.extra1.id &&
          this.props.extra1.id === 1 ? (
            <Field
              addError={self.props.addError}
              clearError={self.props.clearError}
              recordId={self.props.recordData.record.id}
              key={"field-extra4"}
              id="recordExtra4"
              {...Flagship.config.records[this.props.route.type].extra4}
              value={this.props.extra4}
              expanded={false}
              onChange={(e, value) => self.onChangeExtra(e, value, "extra4")}
            />
          ) : null}

          {this.props.instance !== "SHIFT" ||
          this.props.route.type !== "client" ? (
            <Field
              addError={self.props.addError}
              clearError={self.props.clearError}
              recordId={self.props.recordData.record.id}
              key={"field-extra2"}
              id="recordExtra2"
              {...Flagship.config.records[this.props.route.type].extra2}
              value={this.props.extra2}
              expanded={false}
              onChange={(e, value) => self.onChangeExtra(e, value, "extra2")}
            />
          ) : null}
          <Field
            addError={self.props.addError}
            clearError={self.props.clearError}
            recordId={self.props.recordData.record.id}
            key={"field-extra3"}
            id="recordExtra3"
            {...Flagship.config.records[this.props.route.type].extra3}
            value={this.props.extra3}
            expanded={false}
            onChange={(e, value) => self.onChangeExtra(e, value, "extra3")}
          />
          {this.props.route.type === 'client' ? 
          (
          <Field
            addError={self.props.addError}
            clearError={self.props.clearError}
            recordId={self.props.recordData.record.id}
            key={"field-extra4"}
            id="recordExtra4"
            {...Flagship.config.records[this.props.route.type].extra4}
            value={this.props.extra4}
            expanded={false}
            onChange={(e, value) => self.onChangeExtra(e, value, "extra4")}
          />
          )
          : null}
          {this.props.recordFields.map(function (item, i) {
            return shouldShowField(item, self.props.fieldData) ? (
              <Field
                addError={self.props.addError}
                clearError={self.props.clearError}
                recordId={self.props.recordData.record.id}
                key={"field-" + i}
                index={i}
                value={item.field_value}
                onChange={(e, value) => self.onChange(e, value, item)}
                {...item}
              />
            ) : null;
          })}
          <Button
            disabled={
              self.props.requiredMissing || self.props.errors.length
                ? true
                : false
            }
            primary
            onClick={self.props.saveAndExit}
            content="Save Changes"
          />
          {this.props.route.mode === "edit" &&
          this.props.confirmExit === true ? (
            <Modal open={true} onClose={this.props.cancelExit} closeIcon>
              <Header icon="save" content="Save Changes?" />
              <Modal.Content>
                <p>You have unsaved changes. What would you like to do?</p>
              </Modal.Content>
              <Modal.Actions>
                <Button primary onClick={this.props.saveAndExit}>
                  <Icon name="save" /> Save Changes
                </Button>
                <Button secondary onClick={this.props.abandonChanges}>
                  <Icon name="cancel" /> Abandon Changes
                </Button>
                <Button color="grey" onClick={this.props.cancelExit}>
                  <Icon name="dont" /> Cancel
                </Button>
              </Modal.Actions>
            </Modal>
          ) : null}
        </div>
      );
    }
  }
}

export default SingleRecordEdit;



// WEBPACK FOOTER //
// ./src/components/misc/SingleRecordEdit.js